module.exports = __webpack_public_path__ + "img/top-bg.3fdf2a9d.png";